@if (view?.isVisible) {
    <div class="repeatable-row-extra">
        <div class="dose-recommendation-card" [ngClass]="view?.styleClass ?? ''">
            @for (item of view?.items ?? []; track item.label) {
                <div class="dose-recommendation-item" [ngClass]="item.styleClass ?? ''">
                    <span class="dose-recommendation-label">{{ item.label }}</span>
                    <span class="dose-recommendation-value">{{ item.value }}</span>
                </div>
            }
        </div>
    </div>
}
